<mat-card appearance="raised">
  <mat-card-header class="card-header">
    <mat-card-title class="card-header__title-container">
      <ifc-avatar-icon [data]="data.avatar"></ifc-avatar-icon>
      <h2 class="card-header__heading">{{data.fullName}}</h2>
    </mat-card-title>
  </mat-card-header>
  <mat-card-content class="no-bottom-padding">
    <mat-list>
      <mat-list-item>
        <mat-icon matListItemIcon>email</mat-icon>
        <span matListItemTitle>{{data.email || '-'}}</span>
        <span matListItemLine>Email</span>
      </mat-list-item>
      <mat-list-item>
        <mat-icon matListItemIcon>mail</mat-icon>
        <span matListItemTitle>{{data.teamContactEmail || '-'}}</span>
        <span matListItemLine>Team Email</span>
      </mat-list-item>
      <mat-list-item>
        <mat-icon matListItemIcon>phone</mat-icon>
        <span matListItemTitle>{{data?.phone || '-'}}</span>
        <span matListItemLine>Phone</span>
      </mat-list-item>
      <mat-list-item>
        <mat-icon matListItemIcon>cloud</mat-icon>
        <span matListItemTitle
              *ngIf="data.uniqueId">
          <a class="default-link"
             [href]="data.uniqueId | salesforceUrl"
             target="_blank"
             rel="noopener">{{data.uniqueId}}
          </a>
        </span>
        <span matListItemTitle
              *ngIf="!data.uniqueId">-</span>
        <span matListItemLine>Salesforce ID</span>
      </mat-list-item>
      <mat-list-item>
        <mat-icon matListItemIcon>calendar_today</mat-icon>
        <span matListItemTitle
              *ngIf="data.calendarLinkUrl">
          <a class="default-link"
             [href]="data.calendarLinkUrl"
             target="_blank"
             rel="noopener">{{data.calendarLinkUrl}}
          </a>
        </span>
        <span matListItemTitle
              *ngIf="!data.calendarLinkUrl">-</span>
        <span matListItemLine>Calendar link</span>
      </mat-list-item>
    </mat-list>
  </mat-card-content>
</mat-card>
